import { Routes } from '@angular/router';
import { HomeComponent } from './core/home/home';
import { HistoireComponent } from './core/home/histoire/histoire';
import { EtudesBibliquesComponent } from './etudes-bibliques/etudes-bibliques';
import { ContenusVideosComponent } from './ressources/contenus-videos/contenus-videos';
import { AdhererComponent } from './adherer/adherer';
import { FonctionnementComponent } from './core/home/fonctionnement/fonctionnement';
import { DonnerComponent } from './shared/donner/donner';
import { adminGuard } from './shared/auth/admin.guard';
import { EvenementDetailComponent } from './evenements/evenement-detail/evenement-detail';
import { MentionsLegalesComponent } from './legal/mentions-legales/mentions-legales';
import { ContactComponent } from './contact/contact';

export const routes: Routes = [
  { 
    path: '', 
    component: HomeComponent,
    title: 'Accueil - AGBE'
  },
  { 
    path: 'presentation', 
    redirectTo: 'qui-sommes-nous',
    pathMatch: 'full'
  },
  {
    path: 'vision',
    component: HistoireComponent,
    data: { section: 'vision' },
    title: 'Vision & valeurs - AGBE'
  },
  { 
    path: 'qui-sommes-nous', 
    component: HistoireComponent,
    title: 'Qui sommes-nous ? - AGBE'
  },
  { 
    path: 'partenaires', 
    component: HistoireComponent,
    data: { section: 'partenaires' },
    title: 'Partenaires - AGBE'
  },
  { 
    path: 'etudes-bibliques', 
    component: EtudesBibliquesComponent,
    title: 'Etudes Bibliques - AGBE'
  },
  { 
    path: 'ressources/videos', 
    component: ContenusVideosComponent,
    title: 'Contenus Vidéos - AGBE'
  },
  { 
    path: 'adherer', 
    component: AdhererComponent,
    title: 'Adhésion - AGBE'
  },
  { path: 'adhérer', redirectTo: 'adherer', pathMatch: 'full' },
  { path: 'vie-association/priere-evangelisation', loadComponent: () => import('./vie-association/priere-evangelisation').then(m => m.PriereEvangelisationComponent), title: 'Prière & évangélisation - AGBE' },
  { 
    path: 'fonctionnement', 
    component: FonctionnementComponent,
    data: { page: 'functioning' },
    title: 'Fonctionnement - AGBE'
  },
  { path: 'commissions', component: FonctionnementComponent, data: { page: 'commissions' }, title: 'Commissions - AGBE' },
  { 
    path: 'faire-un-don', 
    component: DonnerComponent,
    title: 'Soutenir l\'AGBE'
  },
  { path: 'evenements/:slug', component: EvenementDetailComponent, title: 'Évènement - AGBE' },
  { path: 'mentions-legales', component: MentionsLegalesComponent, title: 'Mentions légales - AGBE' },
  { path: 'contact', component: ContactComponent, title: 'Contact - AGBE' },
  { path: 'actualites', loadComponent: () => import('./actualites/actualites-list').then(m => m.ActualitesListComponent), title: 'Actualités - AGBE' },
  { path: 'actualites/:slug', loadComponent: () => import('./actualites/actualite-detail').then(m => m.ActualiteDetailComponent), title: 'Actualité - AGBE' },
  { path: 'connexion', loadComponent: () => import('./auth/login/login').then(m => m.LoginComponent), title: 'Connexion - AGBE' },
  { path: 'administration', canActivate: [adminGuard], loadComponent: () => import('./admin/admin').then(m => m.AdminComponent), title: 'Administration - AGBE' },
  { path: 'ressources/articles', data: { category: 'articles' }, loadComponent: () => import('./ressources/editorial-list/editorial-list').then(m => m.EditorialListComponent), title: 'Articles et Méditations - AGBE' },
  { path: 'ressources/messages', data: { category: 'messages' }, loadComponent: () => import('./ressources/editorial-list/editorial-list').then(m => m.EditorialListComponent), title: 'Messages des fondateurs - AGBE' },
  { path: 'ressources/famille', data: { category: 'famille' }, loadComponent: () => import('./ressources/editorial-list/editorial-list').then(m => m.EditorialListComponent), title: 'Réflexions sur la famille - AGBE' },
  { path: 'ressources/societe', data: { category: 'societe' }, loadComponent: () => import('./ressources/editorial-list/editorial-list').then(m => m.EditorialListComponent), title: 'Questions de société - AGBE' },
  { path: 'ressources/:category/:slug', loadComponent: () => import('./ressources/editorial-detail/editorial-detail').then(m => m.EditorialDetailComponent), title: 'Publication - AGBE' },
  
  // Redirection par défaut (Wildcard) vers l'accueil si l'URL n'existe pas
  { 
    path: '**', 
    redirectTo: '' 
  }
];
